<template>
  <div class="report-header">
    <client-module :moduletitle="moduletitle">
      <div
        v-if="platForm=='backend'"
        class="site-list"
        slot="customHint"
      >
        <avatar
          :avatarUrl="AvatarUrl"
          class="site-avatar"
          size="30"
        ></avatar>
        <sky-dropdown-select
          @change="changeSite"
          v-model="ServiceId"
          :options="websiteList"
          :props="{ label: 'pageName', value: 'serviceId' }"
        ></sky-dropdown-select>
      </div>
      <el-row class="control-group">
        <!-- 站点切换 -->
        <div
          v-if="platForm=='client'"
          class="site-list"
        >
          <avatar
            :avatarUrl="AvatarUrl"
            class="site-avatar"
            size="30"
          ></avatar>
          <sky-dropdown-select
            @change="changeSite"
            v-model="ServiceId"
            :options="WebsiteList"
            :props="{ label: 'pageName', value: 'serviceId' }"
          ></sky-dropdown-select>
        </div>
        <!-- 日期选择器 -->
        <div
          class="time-switch"
          :style="{justifyContent: platForm=='backend' ? 'flex-start' : 'flex-end'}"
        >
          <sky-dropdown-select
            :options="groups"
            @change="change"
            :value="Selecttimetype"
          >
          </sky-dropdown-select>
          <el-date-picker
            v-model="StartDate"
            :type="PickerType"
            :firstDayOfWeek="1"
            :format="Format"
            :disabled="disabled"
            clearable
            placeholder="请选择日期"
            :picker-options="pickerOptions"
            @change="dataChange"
          >
          </el-date-picker>
          <div
            class="time-date"
            v-if="StartDate"
          >
            <span>{{ StartDate }}</span>
            <span>至</span>
            <span>{{ EndDate }}</span>
          </div>
        </div>
      </el-row>
    </client-module>
  </div>
</template>

<script>
import clientModule from '@/components/client/clientModule/clientModule'
import skyDropdownSelect from '@/components/iglobalwin/formComponents/sky-dropdownSelect'
import { GetMonthStr } from '@/utils/index.js'
import avatar from '@/components/avatar/index.vue'
export default {
  components: {
    clientModule,
    skyDropdownSelect,
    avatar,
  },
  props: {
    platForm: String,
    moduletitle: {
      default: () => 'Facebook Ads广告报告',
    },
    disabled: Boolean,
    avatarUrl: {
      type: String,
    },
    selecttimetype: {
      type: String,
      default: 'WEEKLY',
    },
    pickerType: {
      type: String,
      default: 'week',
    },
    format: {
      type: String,
      default: 'yyyy 第 WW 周',
    },
    serviceId: {
      type: String,
    },
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    websiteList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const that = this
    return {
      ServiceId: '',
      Selecttimetype: '',
      StartDate: '',
      EndDate: '',
      PickerType: '',
      Format: '',
      AvatarUrl: '',
      WebsiteList: '',
      groups: [],
      pickerOptions: {
        disabledDate(time) {
          return that.dealDisabledDate(time)
        },
      },
    }
  },
  watch: {
    disabled: {
      immediate: true,
      handler(val) {
        if (typeof val != 'undefined') {
          this.groups = [
            {
              label: '日报',
              value: 'DAILY',
              disabled: val,
            },
            {
              label: '周报',
              value: 'WEEKLY',
              disabled: val,
            },
            {
              label: '月报',
              value: 'MONTHLY',
              disabled: val,
            },
          ]
        }
      },
    },
    serviceId: {
      immediate: true,
      handler(val) {
        this.ServiceId = val
      },
    },
    selecttimetype: {
      immediate: true,
      handler(val) {
        this.Selecttimetype = val
      },
    },
    pickerType: {
      immediate: true,
      handler(val) {
        this.PickerType = val
      },
    },
    format: {
      immediate: true,
      handler(val) {
        this.Format = val
      },
    },
    startDate: {
      immediate: true,
      handler(val) {
        this.StartDate = val
      },
    },
    endDate: {
      immediate: true,
      handler(val) {
        this.EndDate = val
      },
    },
    avatarUrl: {
      immediate: true,
      handler(val) {
        this.AvatarUrl = val
      },
    },
    websiteList: {
      immediate: true,
      handler(val) {
        this.WebsiteList = val
      },
    },
  },
  methods: {
    // 切换网站
    changeSite() {
      this.$emit('changeSite', this.ServiceId)
    },
    // 时间类型选择
    change(val) {
      this.$emit('change', val)
    },
    // 时间选择
    dataChange(val) {
      this.$emit('dataChange', val)
    },
    dealDisabledDate(time) {
      let { Selecttimetype } = this
      if (Selecttimetype === 'WEEKLY') {
        //按周日为一周的最后一天计算
        var week = new Date()
        //今天是这周的第几天
        var today = week.getDay() * 24 * 3600 * 1000

        // 三个月的开始结束时间
        let date = GetMonthStr(3, 'day')
        let end = new Date(date.last).getTime()
        return time.getTime() > Date.now() - today || time.getTime() < end
      }
      if (Selecttimetype === 'DAILY') {
        // 三个月的开始结束时间
        let date = GetMonthStr(3, 'day')
        let start = new Date(date.now).getTime()
        let end = new Date(date.last).getTime()
        return time.getTime() < end || time.getTime() > start
      }
      if (Selecttimetype === 'MONTHLY') {
        // 三个月的开始结束时间
        let date = GetMonthStr(3, 'day')
        let end = new Date(date.last).getTime()
        return time.getTime() > Date.now() || time.getTime() < end
      }
    },
  },
  mounted() {
    if (typeof this.disabled == 'undefined') {
      this.groups = [
        {
          label: '日报',
          value: 'DAILY',
        },
        {
          label: '周报',
          value: 'WEEKLY',
        },
        {
          label: '月报',
          value: 'MONTHLY',
        },
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
.report-header {
  background-color: white;
  box-shadow: 0px 2px 6px 0px rgba(233, 236, 248, 1);
  border-radius: 4px;
}
.control-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.site-list {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-left: 20px;
  height: 60px;
  flex: 1;
  .site-avatar {
    margin-right: 20px;
  }
}
.time-switch {
  width: 100%;
  flex: 1;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 24px;
  .el-date-editor {
    margin-left: 52px;
    .el-range-separator {
      padding: 0;
    }
  }

  .time-date {
    color: #666;
    margin-left: 20px;
    font-size: 16px;
  }
  .el-dropdown {
    color: #5aa0ff;
  }
}
</style>